<template>
	<!--Desktop view -->
	<v-card
		v-if="!$vuetify.breakpoint.mdAndDown"
		elevation="0"
		width="100%"
		:loading="isLoadingCliente"
	>
		<v-list-item v-if="cliente">
			<v-list-item-content>
				<v-list-item-title>
					<!-- <div class="d-flex justify-center my-4">
						<v-btn disabled @click="descargarPdfOferta">
							<v-icon left> mdi-file-download-outline </v-icon>
							Descargar oferta
						</v-btn>
					</div> -->
					<div>
						<v-chip
							color="primary"
							large
							label
							outlined
							class="
								d-flex
								justify-center
								text-wrap text-center
								py-2
							"
							style="width: 100%; height: 140%"
						>
							<v-row
								no-gutters
								align="center"
								justify="center"
								class="d-flex flex-grow"
							>
								<v-col
									class="pa-2 d-flex justify-center"
									cols="2"
								>
									<v-icon size="40">
										mdi-account-circle-outline
									</v-icon>
								</v-col>
								<v-col cols="10">
									<div class="d-block align-center">
										<p class="ma-0 font-weight-medium">
											{{
												cliente.nombre
													? cliente.nombre
													: 'Sin nombre asignado'
											}}
										</p>
										<p
											class="
												ma-0
												font-weight-light
												text-center
											"
											v-if="cliente.documento"
										>
											{{ cliente.tipoDocumento }} -
											{{ cliente.documento }}
										</p>
									</div>
								</v-col>
							</v-row>
						</v-chip>
					</div>
					<div
						v-if="cliente.segmento"
						class="d-flex mt-2 justify-center"
					>
						<v-chip
							style="width: 100%"
							color="primary"
							label
							outlined
							class="d-flex align-center justify-center"
						>
							<v-icon left> mdi-star </v-icon>
							<p class="ma-0">
								{{ cliente.segmento }}
							</p>
						</v-chip>
					</div>
				</v-list-item-title>
			</v-list-item-content>
		</v-list-item>

		<div v-if="cliente && cliente.telefonosContacto.length != 0">
			<!-- <v-divider /> -->
			<div
				id="lineas-asociadas"
				class="d-flex flex-wrap justify-center mt-n2 pb-3"
				:style="
					cliente.telefonosContacto.length > 2
						? 'height: 100px;overflow-y: scroll;'
						: ''
				"
			>
				<v-chip
					style="width: 100%"
					v-for="telefono in cliente ? cliente.telefonosContacto : []"
					:key="telefono"
					color="primary"
					outlined
					label
					class="d-flex align-center justify-center ma-1 mx-4"
				>
					<v-icon left> mdi-phone </v-icon>
					<p class="ma-0">
						{{ telefono }}
					</p>
				</v-chip>
			</div>
		</div>

		<!-- <v-divider /> -->

		<div>
			<v-combobox
				class="px-8 pt-8"
				filled
				clearable
				prepend-inner-icon="mdi-phone-message-outline"
				:error-messages="numeroComercialErrors"
				style="border-radius: 10px;"
				v-model="numeroComercial"
				:items="
					hasAdminPermission
						? comercialAtencion
							? comercialAtencion.numerosContacto
								? comercialAtencion.numerosContacto
								: []
							: []
						: cuenta.numeros_contacto
				"
				label="Teléfono de Contacto"
			></v-combobox>
		</div>

		<!-- <v-divider /> -->

		<v-select
			class="px-8 pt-8"
			filled
			:clearable="hasManagerPermission"
			required
			prepend-inner-icon="mdi-clipboard-account-outline"
			style="border-radius: 10px;"
			:readonly="hasComercialPermission || hasOnlyManagerPermission"
			v-model="comercial"
			:items="comerciales"
			label="Comercial"
			:disabled="configuratorType == 'EDIT'"
			item-text="nombreCompleto"
			item-value="id"
		>
			<template #item="{ item }">
				<v-row style="width: 400px">
					<v-col cols="8">
						{{ item.nombreCompleto }}
					</v-col>
					<v-col v-if="item.estado" cols="4">
						<v-chip
							label
							:color="estadoComercial[item.estado]"
							medium
							class="d-flex justify-center overline"
						>
							{{ item.estado }}
						</v-chip>
					</v-col>
				</v-row>
			</template>
		</v-select>

		<v-select
			class="px-8 py-2"
			filled
			clearable
			style="border-radius: 10px;"
			prepend-inner-icon="mdi-map-marker-radius-outline"
			v-model="selectedLocation"
			:items="opciones ? opciones.oferta.ubicacion : []"
			item-text="human"
			item-value="encoded"
			return-object
			label="Tipo de iva"
		></v-select>
		<v-select
			class="px-8 py-2"
			filled
			style="border-radius: 10px;"
			prepend-inner-icon="mdi-access-point"
			v-model="selectedOperator"
			:items="opciones ? opciones.cliente.isp : []"
			item-text="human"
			:disabled="configuratorType == 'EDIT'"
			item-value="encoded"
			label="Operador actual del cliente"
		></v-select>

		<!-- <v-divider></v-divider> -->

		<!-- <v-card elevation="0" outlined class="my-4 mx-7">
            <v-toolbar flat dense color="#F0F0F0" class="d-flex justify-center">
                <v-toolbar-title>
                    <span class="text-h7 text-wrap text-overline">
                        Renuevo
                    </span>
                </v-toolbar-title>
            </v-toolbar>

            <v-divider></v-divider>

            <v-card-text class="my-2 py-0">
                <RenuevoView
                    class="py-2"
                    :info="{
                        documentType:
                            cliente && cliente.tipoDocumento
                                ? cliente.tipoDocumento
                                : null,
                        document:
                            cliente && cliente.documento
                                ? cliente.documento
                                : null,
                        contactNumbers:
                            cliente && cliente.telefonosContacto
                                ? cliente.telefonosContacto
                                : [],
                    }"
                />
            </v-card-text>
        </v-card> -->

		<v-container>
			<v-card elevation="0" class="ma-4">
				<v-toolbar
					flat
					dense
					class="d-flex justify-center"
				>
					<v-toolbar-title>
						<span class="text-h7 text-wrap text-overline">
							Precio mensual actual
						</span>
					</v-toolbar-title>
				</v-toolbar>

				<!-- <v-divider></v-divider> -->

				<v-card-text class="my-2 py-0">
					<div class="d-flex justify-center">
						<div>
							<v-textarea
								class="display-1"
								clearable
								no-resize
								append-outer-icon="mdi-currency-eur"
								clear-icon="mdi-close-circle"
								v-model="precioMensOtro"
								style="width: 170px"
							></v-textarea>
						</div>
					</div>

					<div>
						<v-slider
							v-model="precioMensOtro"
							:color="colorOperador(precioMensOtro)"
							min="0"
							max="1400"
							:disabled="configuratorType == 'EDIT'"
							always-dirty
						>
							<template v-slot:prepend>
								<v-icon @click="decrementPrecioMensOtro">
									mdi-minus
								</v-icon>
							</template>

							<template v-slot:append>
								<v-icon @click="incrementPrecioMensOtro">
									mdi-plus
								</v-icon>
							</template>
						</v-slider>
					</div>
				</v-card-text>
			</v-card>

			<!-- <v-divider></v-divider> -->

			<v-card elevation="0" class="my-4 mx-4">
				<v-toolbar
					flat
					dense
					class="d-flex justify-center"
				>
					<v-toolbar-title>
						<span class="text-h7 text-wrap text-overline">
							Notas
						</span>
					</v-toolbar-title>
				</v-toolbar>

				<!-- <v-divider></v-divider> -->

				<v-card-text class="my-2 py-0">
					<v-textarea
						append-icon="mdi-comment"
						class="mx-2"
						label="Comentarios"
						v-model="notas"
						auto-grow
					></v-textarea>
				</v-card-text>
			</v-card>
		</v-container>
	</v-card>

	<!--Movile view-->
	<v-card v-else elevation="0" width="100%" :loading="isLoadingCliente">
		<v-list-item v-if="cliente">
			<v-list-item-content>
				<v-list-item-title>
					<!-- <div class="d-flex justify-center my-4">
						<v-btn disabled @click="descargarPdfOferta">
							<v-icon left> mdi-file-download-outline </v-icon>
							Descargar oferta
						</v-btn>
					</div> -->
					<div>
						<v-chip
							color="primary"
							large
							label
							outlined
							class="
								d-flex
								justify-center
								text-wrap text-center
								py-2
							"
							style="width: 100%; height: 140%"
						>
							<v-row
								no-gutters
								align="center"
								justify="center"
								class="d-flex flex-grow"
							>
								<v-col
									class="pa-2 d-flex justify-center"
									cols="2"
								>
									<v-icon size="40">
										mdi-account-circle-outline
									</v-icon>
								</v-col>
								<v-col cols="10">
									<div class="d-block align-center">
										<p class="ma-0 font-weight-medium">
											{{
												cliente.nombre
													? cliente.nombre
													: 'Sin nombre asignado'
											}}
										</p>
										<p
											class="
												ma-0
												font-weight-light
												text-center
											"
											v-if="cliente.documento"
										>
											{{ cliente.tipoDocumento }} -
											{{ cliente.documento }}
										</p>
									</div>
								</v-col>
							</v-row>
						</v-chip>
					</div>
					<div
						v-if="cliente.segmento"
						class="d-flex mt-2 justify-center"
					>
						<v-chip
							style="width: 100%"
							color="primary"
							label
							outlined
							class="d-flex align-center justify-center"
						>
							<v-icon left> mdi-star </v-icon>
							<p class="ma-0">
								{{ cliente.segmento }}
							</p>
						</v-chip>
					</div>
					<v-divider></v-divider>
					<div
						v-if="cliente && cliente.telefonosContacto.length != 0"
					>
						<!-- <v-divider /> -->
						<div id="lineas-asociadas" class="mt-2 justify-center">
							<v-chip
								style="width: 100%"
								v-for="telefono in cliente
									? cliente.telefonosContacto
									: []"
								:key="telefono"
								color="primary"
								label
								outlined
								class="d-flex mt-2 align-center justify-center"
							>
								<v-icon left> mdi-phone </v-icon>
								<p class="ma-0">
									{{ telefono }}
								</p>
							</v-chip>
						</div>
					</div>
				</v-list-item-title>
			</v-list-item-content>
		</v-list-item>
		<v-card-actions class="d-flex justify-center">
			<v-btn style="width: 100%;" depressed @click="show = !show">
				<v-icon>{{
					show ? 'mdi-chevron-up' : 'mdi-chevron-down'
				}}</v-icon>
			</v-btn>
		</v-card-actions>

		<v-expand-transition>
			<div v-show="show">
				<div>
					<v-combobox
						class="px-8 pt-8"
						filled
						clearable
						prepend-inner-icon="mdi-phone-message-outline"
						:error-messages="numeroComercialErrors"
						style="border-radius: 10px;"
						v-model="numeroComercial"
						:items="
							hasAdminPermission
								? comercialAtencion
									? comercialAtencion.numerosContacto
										? comercialAtencion.numerosContacto
										: []
									: []
								: cuenta.numeros_contacto
						"
						label="Teléfono de Contacto"
					></v-combobox>
				</div>

				<v-divider />

				<v-select
					class="px-8 pt-8"
					filled
					clearable
					required
					prepend-inner-icon="mdi-clipboard-account-outline"
					style="border-radius: 10px;"
					:readonly="
						hasComercialPermission || hasOnlyManagerPermission
					"
					v-model="comercial"
					:items="comerciales"
					label="Comercial"
					:disabled="configuratorType == 'EDIT'"
					item-text="nombreCompleto"
					item-value="id"
				>
					<template #item="{ item }">
						<v-row style="width: 400px">
							<v-col cols="8">
								{{ item.nombreCompleto }}
							</v-col>
							<v-col v-if="item.estado" cols="4">
								<v-chip
									label
									:color="estadoComercial[item.estado]"
									medium
									class="d-flex justify-center overline"
								>
									{{ item.estado }}
								</v-chip>
							</v-col>
						</v-row>
					</template>
				</v-select>

				<v-select
					class="px-8 py-2"
					filled
					clearable
					style="border-radius: 10px;"
					prepend-inner-icon="mdi-map-marker-radius-outline"
					v-model="selectedLocation"
					:items="opciones ? opciones.oferta.ubicacion : []"
					item-text="human"
					item-value="encoded"
					return-object
					label="Tipo de iva"
				></v-select>
				<v-select
					class="px-8 py-2"
					filled
					style="border-radius: 10px;"
					prepend-inner-icon="mdi-access-point"
					v-model="selectedOperator"
					:items="opciones ? opciones.cliente.isp : []"
					item-text="human"
					:disabled="configuratorType == 'EDIT'"
					item-value="encoded"
					label="Operador actual del cliente"
				></v-select>

				<!-- <v-divider></v-divider> -->

				<v-card v-if="ckeckGroupPermission([GROUPS.MASMOVIL])" elevation="0" class="my-4 mx-7">
					<v-toolbar
						flat
						dense
						class="d-flex justify-center"
					>
						<v-toolbar-title>
							<span class="text-h7 text-wrap text-overline">
								Renuevo
							</span>
						</v-toolbar-title>
					</v-toolbar>

					<v-divider></v-divider>

					<v-card-text class="my-2 py-0">
						<RenuevoView
							class="py-2"
							:info="{
								documentType:
									cliente && cliente.tipoDocumento
										? cliente.tipoDocumento
										: null,
								document:
									cliente && cliente.documento
										? cliente.documento
										: null,
								contactNumbers:
									cliente && cliente.telefonosContacto
										? cliente.telefonosContacto
										: [],
							}"
						/>
					</v-card-text>
				</v-card>

				<v-card elevation="0" class="ma-4">
					<v-toolbar
						flat
						dense
						class="d-flex justify-center"
					>
						<v-toolbar-title>
							<span class="text-h7 text-wrap text-overline">
								Precio mensual actual
							</span>
						</v-toolbar-title>
					</v-toolbar>

					<!-- <v-divider></v-divider> -->

					<v-card-text class="my-2 py-0">
						<div class="d-flex justify-center">
							<div>
								<v-textarea
									class="display-1"
									clearable
									no-resize
									append-outer-icon="mdi-currency-eur"
									clear-icon="mdi-close-circle"
									v-model="precioMensOtro"
									style="width: 170px"
								></v-textarea>
							</div>
						</div>

						<div>
							<v-slider
								v-model="precioMensOtro"
								:color="colorOperador(precioMensOtro)"
								min="0"
								max="200"
								:disabled="configuratorType == 'EDIT'"
								always-dirty
							>
								<template v-slot:prepend>
									<v-icon @click="decrementPrecioMensOtro">
										mdi-minus
									</v-icon>
								</template>

								<template v-slot:append>
									<v-icon @click="incrementPrecioMensOtro">
										mdi-plus
									</v-icon>
								</template>
							</v-slider>
						</div>
					</v-card-text>
				</v-card>

				<!-- <v-divider></v-divider> -->

				<v-card elevation="0" class="my-4 mx-4">
					<v-toolbar
						flat
						dense
						class="d-flex justify-center"
					>
						<v-toolbar-title>
							<span class="text-h7 text-wrap text-overline">
								Notas
							</span>
						</v-toolbar-title>
					</v-toolbar>

					<!-- <v-divider></v-divider> -->

					<v-card-text class="my-2 py-0">
						<v-textarea
							append-icon="mdi-comment"
							class="mx-2"
							label="Comentarios"
							auto-grow
							v-model="notas"
						></v-textarea>
					</v-card-text>
				</v-card>
			</div>
		</v-expand-transition>
	</v-card>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import RenuevoView from '@/components/ComercialTeletrabajo/DetailedView/RenuevoView.vue';

export default {
	name: 'ConfiguratorAside',
	components: {
		RenuevoView,
	},
	data: () => ({
		estadoComercial: {
			ALTA: 'success',
			BAJA: 'warning',
			INACTIVO: 'error',
			VACACIONES: 'blue',
		},
		numeroComercialErrors: [],
		potencial: true,
		items: [
			{
				title: 'Ubicación',
				icon: 'mdi-cash-marker',
			},
			{
				title: 'Operador cliente',
				icon: 'mdi-server-network',
			},
			{
				title: 'TOTAL',
				icon: 'mdi-cash',
			},
			{
				title: 'Diferencia mes',
				icon: 'mdi-cash-minus',
			},
			{
				title: 'Diferencia anual',
				icon: 'mdi-cash-multiple',
			},
		],
		setNotas: {
			YOIGOPARTICULAR:
				'Completa tu pedido, añadiendo un gran catálogo de canales con Agile TV, salud online para todos los bolsillos con Doctor Go, incluso paga menos en la factura de la luz con Energy Go.',
			YOIGONEGOCIOS:
				'Completa tu pedido, añadiendo un gran catálogo de canales con Agile TV, incluso paga menos en la factura de la luz con Energy Go.',
			MASMOVILPARTICULAR:
				'Completa tu pedido, añadiendo un gran catálogo de canales con Agile TV, ahorra en la factura de la luz contratando MasMóvil Energía, sin instalaciones, papeleos ni permanencias.',
			MASMOVILNEGOCIOS:
				'Ahorra en la factura de la luz contratando MasMóvil Energía, sin instalaciones, papeleos ni permanencias.',
			PEPEPHONEPARTICULAR:
				'No olvides contratrar la Energía con PepePhone, PepeEnergy luz 100% verde a un precio justo, sin instalación, ni compromiso.',
			LEBARAPARTICULAR: '',
			LLAMAYAPARTICULAR: '',
			VIRGINPARTICULAR:
				'Completa tu pedido, añadiendo un gran catálogo de canales con Agile TV',
			DBL: 'Completa tu pedido, añadiendo un gran catálogo de canales con Agile TV, incluso paga menos en la factura de la luz con Energy Go.',
		},
		show: false,
	}),

	methods: {
		colorOperador(value) {
			if (value < 50) return 'green';
			if (value < 100) return 'orange';
			return 'red';
		},
		decrementPrecioMensOtro() {
			this.$store.commit(
				'configuradorOferta/precioMensOtro',
				Number(this.$store.state.configuradorOferta.precioMensOtro) - 1
			);
		},
		incrementPrecioMensOtro() {
			this.$store.commit(
				'configuradorOferta/precioMensOtro',
				Number(this.$store.state.configuradorOferta.precioMensOtro) + 1
			);
		},
		clearFields() {
			let defaultPackage = {
				family: '',
				tariff: '',
				linkedPhoneNumbers: [],
				sellingUnit: '',
				terminal: '',
				hasInsurance: '',
			};

			this.$store.state.configuradorOferta.precioMensOtro = 0;
			this.$store.state.configuradorOferta.precioActualYG = 0;
			this.$store.state.configuradorOferta.cuotaTerminales = 0;
			this.$store.state.configuradorOferta.selectedLocation = 0;
			this.$store.state.configuradorOferta.hasAdditionals = false;
			this.$store.state.configuradorOferta.fiberPackages = [
				defaultPackage,
			];
			this.$store.state.configuradorOferta.aditionalPackages = [
				defaultPackage,
			];
			this.$store.state.configuradorOferta.mainLine = defaultPackage;
			this.$store.state.configuradorOferta.selectedSVAs = [];
			this.potencial = false;
			this.selectedOperator = '';
		},
		updateNumFibraFijo() {
			if (this.$store.state.configuradorOferta.hasAdditionals)
				this.$store.commit('configuradorOferta/numFibraFijo', 1);
			else this.$store.commit('configuradorOferta/numFibraFijo', 0);
		},
		autoFillComercial() {
			if (
				this.comerciales
					.filter(({rol}) => !rol || rol.id == 4)
					.map(({ id }) => id)
					.includes(this.$store.state.login.id)
			) {
				this.atencion.comercial = this.comerciales.find(
					({ id }) => id == this.$store.state.login.id
				);
				this.numeroComercial = this.cuenta.numeros_contacto
					? this.cuenta.numeros_contacto[0]
					: null;
			} else if (this.comercial && this.comercial.numerosContacto) {
				this.numeroComercial = this.comerciales.find(
					({ id }) => id == this.comercial
				).numerosContacto[0];
			}
		},
		...mapActions('configuradorOferta', {
			descargarPdfOferta: 'descargarPdfOferta',
		}),
	},
	computed: {
		opciones() {
			return JSON.parse(localStorage.getItem('opciones'));
		},
		cuenta() {
			return JSON.parse(localStorage.getItem('cuenta'));
		},
		numeroComercial: {
			get() {
				return this.$store.state.configuradorOferta.numeroComercial;
			},
			set(val) {
				this.$store.state.configuradorOferta.numeroComercial = val;
			},
		},
		notas: {
			get() {
				return this.$store.state.configuradorOferta.atencion.notas;
			},
			set(val) {
				this.$store.state.configuradorOferta.atencion.notas = val;
			},
		},
		hasAdditionals: {
			get() {
				return this.$store.state.configuradorOferta.hasAdditionals;
			},
			set(val) {
				this.$store.commit('configuradorOferta/hasAdditionals', val);
			},
		},
		precioMensOtro: {
			get() {
				return this.$store.state.configuradorOferta.precioMensOtro;
			},
			set(val) {
				this.$store.commit(
					'configuradorOferta/precioMensOtro',
					val ? parseInt(val) : 0
				);
			},
		},
		precioActualYG: {
			get() {
				return this.$store.state.configuradorOferta.precioActualYG;
			},
			set(val) {
				this.$store.commit('configuradorOferta/precioActualYG', val);
			},
		},
		cuotaTerminales: {
			get() {
				return this.$store.state.configuradorOferta.cuotaTerminales;
			},
			set(val) {
				this.$store.commit('configuradorOferta/cuotaTerminales', val);
			},
		},
		selectedLocation: {
			get() {
				return this.$store.state.configuradorOferta.selectedLocation;
			},
			set(val) {
				this.$store.commit('configuradorOferta/selectedLocation', val);
			},
		},
		comercial: {
			get() {
				return this.atencion.comercial
					? this.atencion.comercial.id
					: '';
			},
			set(val) {
				const comercial = this.comerciales.find(
					({ id }) => id == val
				);
				this.$store.commit('configuradorOferta/comercial', comercial);
			},
		},
		selectedOperator: {
			get() {
				return this.$store.state.configuradorOferta.operador;
			},
			set(val) {
				this.$store.commit('configuradorOferta/operador', val);
			},
		},
		...mapState('configuradorOferta', {
			mainLine: (state) => state.mainLine,
			cliente: (state) => state.cliente,
			atencion: (state) => state.atencion,
			comercialAtencion: (state) => state.atencion.comercial,
			isp: (state) => state.isp,
			configuratorType: (state) => state.configuratorType,
			isLoadingCliente: (state) => state.isLoadingCliente,
		}),
		...mapGetters('teletrabajo', {
			comerciales: 'allComerciales',
		}),
		...mapGetters('login', {
			hasManagerPermission: 'hasManagerPermission',
			hasAdminPermission: 'hasAdminPermission',
			hasOnlyManagerPermission: 'hasOnlyManagerPermission',
			hasComercialPermission: 'hasComercialPermission',
		}),
		...mapState('general', {
			GROUPS: (state) => state.GROUPS,
		}),
		...mapGetters('login', {
			ckeckGroupPermission: 'ckeckGroupPermission',
		}),
	},
	mounted() {
		this.$store.commit('configuradorOferta/precioMensOtro', 0.0);
		if (!this.comerciales || this.comerciales.length == 0) {
			this.$store.dispatch('teletrabajo/fetchComerciales').then(() => {
				this.autoFillComercial();
			});
		} else {
			this.autoFillComercial();
		}

		this.selectedLocation = this.opciones
			? this.opciones.oferta.ubicacion[0]
			: '';
	},
	watch: {
		comercial: {
			immediate: true,
			handler: function () {
				this.numeroComercial = null;
			},
		},
		numeroComercial: {
			immediate: true,
			handler(val) {
				let regexTelefono = /^(6|7|8|9)([0-9]){8}$/;

				if (val && typeof val == 'string' && !regexTelefono.test(val)) {
					this.numeroComercialErrors =
						'El número introducido no es correcto y se ha eliminado';
					this.numeroComercial = [];

					setTimeout(() => {
						this.numeroComercialErrors = [];
					}, 2500);
				}
			},
		},
		atencion: {
			immediate: true,
			handler() {
				if (this.isp && this.configuratorType != 'EDIT')
					this.atencion.notas = this.setNotas[this.isp.alt];
			},
		},
		cliente: {
			immediate: true,
			handler: function () {
				this.cliente &&
					(this.selectedOperator = this.cliente.ispActual);
			},
		},
		comercialAtencion: {
			immediate: true,
			handler: function () {
				this.autoFillComercial();
			},
		},
	},
};
</script>

<style>
textarea {
	padding-top: 5px !important;
	padding-bottom: 0px !important;
	height: 40px;
}
</style>